import { createApp } from "vue";
import AppWrapper from "./AppWrapper.vue";

import "./css-reset.css";
import "./global.css";
import { visible } from "@fresh8/vue-utils/src/directives/visible";
import { adtag } from "./prefetch";
import { F8LoadingError } from "./lib/loading";

Promise.allSettled([adtag()]).then(([adTag]) => {
  if (adTag.status === "rejected") {
    F8LoadingError();
  } else {
    const App = createApp(AppWrapper, { adTag: adTag.value });
    App.directive("visible", visible);
    App.mount("#app");
  }
});
